module.exports = __webpack_public_path__ + "static/media/gps.5a791431.png";